import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setRelationshipType } from '../features/contestants/contestantsSlice';
import BackgroundContainer from '../components/BackgroundContainer';
import BaseButton from '../components/BaseButton';
import BaseHeader from '../components/BaseHeader';
import MenuButton from '../components/MenuButton';

const relationships = [
  {
    id: 'long_term',
    headline: 'Long Term Couple',
    description: 'Dating for a long time and married couples',
  },
  {
    id: 'first_dates',
    headline: 'First 10 Dates',
    description: 'Dating seriously, but just getting to know each other',
  },
  {
    id: 'casual',
    headline: 'Casual',
    description: 'Friends with benefits, or any casual connection',
  },
];

const ChooseRelationship = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const savedType = useSelector((state) => state.contestants.relationshipType);
  const [selectedType, setSelectedType] = useState(savedType || 'long_term');

  const handleNext = () => {
    dispatch(setRelationshipType(selectedType));
    navigate('/choosegamemode');
  };

  return (
    <BackgroundContainer>
      <MenuButton showLogin={true} faq={true} showAccount={true} showDownload={true} />
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <BaseHeader
          sx={{
            marginBottom: '1rem',
            textAlign: 'center',
            fontSize: '4.2rem',
            '@media (max-width: 450px)': { fontSize: '3.9rem' },
            '@media (max-width: 410px)': { fontSize: '3.5rem' },
            '@media (max-width: 376px)': { fontSize: '3rem' },
            '@media (max-width: 320px)': { fontSize: '2.9rem' },
            '@media (max-height: 700px)': { marginBottom: '0.4rem' },
            '@media (max-height: 600px)': { marginBottom: '0.2rem', fontSize: '3rem' },
          }}
        >
          Your Story?
        </BaseHeader>

        {relationships.map((rel) => {
          const isSelected = selectedType === rel.id;
          return (
            <Box
              key={rel.id}
              onClick={() => setSelectedType(rel.id)}
              sx={{
                width: '75%',
                maxWidth: '340px',
                margin: '8px auto',
                padding: '18px 24px',
                borderRadius: '16px',
                cursor: 'pointer',
                WebkitTapHighlightColor: 'transparent',
                outline: 'none',
                userSelect: 'none',
                transition: 'border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease',
                background: isSelected
                  ? 'linear-gradient(180deg, rgba(120, 30, 80, 0.6) 0%, rgba(60, 10, 40, 0.8) 100%)'
                  : 'linear-gradient(180deg, rgba(30, 10, 25, 0.7) 0%, rgba(20, 6, 18, 0.85) 100%)',
                border: isSelected
                  ? '1.5px solid rgba(205, 80, 150, 0.75)'
                  : '1.5px solid rgba(140, 50, 100, 0.3)',
                boxShadow: isSelected
                  ? '0 0 20px rgba(180, 60, 130, 0.35), 0 4px 16px rgba(0,0,0,0.5)'
                  : '0 2px 10px rgba(0,0,0,0.4)',
                transform: isSelected ? 'scale(1.02)' : 'scale(1)',
                '&:active': {
                  transform: 'scale(0.98)',
                  boxShadow: '0 0 14px rgba(180, 60, 130, 0.3), 0 2px 8px rgba(0,0,0,0.4)',
                },
                '@media (max-height: 700px)': {
                  margin: '4px auto',
                  padding: '12px 20px',
                  borderRadius: '12px',
                },
                '@media (max-height: 600px)': {
                  margin: '2px auto',
                  padding: '8px 16px',
                  borderRadius: '10px',
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Playfair Display, serif',
                  fontSize: '1.4rem',
                  fontWeight: 700,
                  color: isSelected ? '#e8c0d8' : '#b08898',
                  letterSpacing: '0.04em',
                  marginBottom: '6px',
                  '@media (max-height: 700px)': { fontSize: '1.2rem', marginBottom: '3px' },
                  '@media (max-height: 600px)': { fontSize: '1rem', marginBottom: '2px' },
                }}
              >
                {rel.headline}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Cormorant Garamond, serif',
                  fontSize: '1rem',
                  color: isSelected ? '#c49ab8' : '#8a6878',
                  letterSpacing: '0.02em',
                  '@media (max-height: 700px)': { fontSize: '0.88rem' },
                  '@media (max-height: 600px)': { fontSize: '0.78rem' },
                }}
              >
                {rel.description}
              </Typography>
            </Box>
          );
        })}
      </Box>

      <Box sx={{ marginTop: '10px', marginBottom: '10px', display: 'flex', justifyContent: 'center' }}>
        <BaseButton onClick={() => navigate('/contestants')}>Back</BaseButton>
        <BaseButton onClick={handleNext} disabled={!selectedType}>Next</BaseButton>
      </Box>
    </BackgroundContainer>
  );
};

export default ChooseRelationship;
